import {AllocationMethod} from '@/model/src/values/dv-102';
import {DomainValueReference} from '@/model/types';

const SPLIT_OPTION_TO_DV_MAPPING: Record<string, AllocationMethod> = {
  '%': AllocationMethod.PERCENTAGE,
  '$': AllocationMethod.AMOUNT,
};

export const mapSplitOptionToDomainValue = (splitOption?: string): DomainValueReference | null => {
  if (!splitOption || !(splitOption in SPLIT_OPTION_TO_DV_MAPPING)) return null;

  return {$ref: SPLIT_OPTION_TO_DV_MAPPING[splitOption]};
};
